import type { IJsonSchema, IJsonSchemaCompensationPackage } from "types/jsonSchema";
import type { CompensationPackage } from "types/salaryRange";
import type { IUiSchema } from "types/uiSchema";

/**
 * Extracts compensation package data from UI schema
 * @param uiSchema - The UI schema containing form configuration
 * @returns CompensationPackage data or null if not available
 */
export const extractCompensationPackageData = (uiSchema: IUiSchema | null | undefined): CompensationPackage | null => {
    const compensationPackage = uiSchema?.["x-form-compensation-package"];

    if (!compensationPackage) {
        return null;
    }

    return {
        salaryRanges: compensationPackage.salaryRanges ?? undefined,
        benefits: compensationPackage.benefits ?? undefined,
        showCompensationPackage: compensationPackage.showCompensationPackage ?? false,
    };
};

/**
 * Extracts compensation package schema from JSON schema
 * @param jsonSchema - The JSON schema containing form validation rules
 * @returns IJsonSchemaCompensationPackage or null if not available
 */
export const extractCompensationPackageSchema = (
    jsonSchema: IJsonSchema | null | undefined,
): IJsonSchemaCompensationPackage | null => {
    const compensationPackageProperty = jsonSchema?.properties?.compensationPackage as IJsonSchemaCompensationPackage;

    if (!compensationPackageProperty || compensationPackageProperty.type !== "object") {
        return null;
    }

    return compensationPackageProperty;
};
